import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { useI18n } from '@openclassrooms/translations/I18nProvider';

import Button from '@classify/react-core-components/Button';
import IconButton from '@classify/react-core-components/IconButton';

import { ContactButton } from './ContactButton';

export function HeaderContactButton({ isSmall }: { isSmall?: boolean }) {
  const { translate } = useI18n();

  return (
    <ContactButton
      render={({ onClick }) =>
        isSmall ? (
          <IconButton
            tooltip={translate('main_header.support')}
            aria-label={translate('main_header.support')}
            onClick={onClick}
          >
            <HelpOutlineIcon sx={{ width: 28, height: 28 }} />
          </IconButton>
        ) : (
          <Button variant="secondary" onClick={onClick}>
            {translate('main_header.support')}
          </Button>
        )
      }
    />
  );
}
